import React from 'react';
import PropTypes from 'prop-types';

import { genericObject } from 'core/utils/prop-types/model';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

import LineOfContents from './lineOfContents';

const TableOfContents = ({ widgets, tableOfContentsAtoms, tableOfContentsTitle, shapkaHeight }) => {
  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .table-of-contents
          clear both
          max-width ${tableOfContentsAtoms.maxWidth}
          padding ${tableOfContentsAtoms.padding}
          margin ${tableOfContentsAtoms.margin}
          border-bottom ${tableOfContentsAtoms.borderBottom}

        .table-of-contents-title
          font ${tableOfContentsAtoms.title.font}
          color ${tableOfContentsAtoms.title.color}
          display ${tableOfContentsAtoms.title.display}

        .table-of-contents-list
          margin 0
          padding ${tableOfContentsAtoms.listPadding}
          list-style ${tableOfContentsAtoms.listStyle}
          :global(a)
            color ${tableOfContentsAtoms.link.color}

        :global([id])
          scroll-margin-top ${shapkaHeight ? shapkaHeight + 'px' : 0}
      `}</style>
    </scope>
  );

  const content = widgets.map((block, i) => {
    if (!block) return null;

    const {
      type,
      attributes: {
        body,
      },
    } = block;

    if (type === 'markdown' && /#{2}/.test(body)) {
      return (
        <LineOfContents
          key={i}
          position={i}
          body={body}
        />
      );
    }

    return null;
  })
    .filter(Boolean);


  return (
    <nav className={scoped.wrapClassNames('table-of-contents')}>
      <div className={scoped.wrapClassNames('table-of-contents-title')}>
        {tableOfContentsTitle || 'Оглавление'}
      </div>
      <ul className={scoped.wrapClassNames('table-of-contents-list')}>
        {content}
      </ul>
      <scoped.styles />
    </nav>
  );
};

TableOfContents.propTypes = {
  widgets: PropTypes.arrayOf(genericObject).isRequired,
  tableOfContentsTitle: PropTypes.string,
  tableOfContentsAtoms: PropTypes.shape({
    maxWidth: PropTypes.string,
    padding: PropTypes.string,
    margin: PropTypes.string,
    borderBottom: PropTypes.string,
    title: PropTypes.shape({
      font: PropTypes.string,
      color: PropTypes.string,
      display: PropTypes.string,
    }),
    listPadding: PropTypes.string,
    listStyle: PropTypes.string,
    link: PropTypes.shape({
      color: PropTypes.string,
    }),
  }),
  shapkaHeight: PropTypes.number,
};

export default TableOfContents;
